import { CanonicalDocument, CanonicalLineItem, CanonicalReviewCase, ReviewAssignmentState } from '../cases/case.models';

const document = (id: string, fileName: string, sourceId: string): CanonicalDocument => ({ id, fileName, sizeBytes: 2_048, mediaType: 'text/plain', scope: 'case', revision: 1, sourceId });

function line(id: string, code: string, qpaCents: number | null, partyAmount: number | null, planAmount: number | null, partySubmitted = true): CanonicalLineItem {
  return {
    id,
    serviceCode: code,
    serviceDescription: 'Emergency physician service',
    serviceDate: 'August 2, 2026',
    qpaCents,
    offers: [
      {
        id: `${id}-party`,
        organizationId: 'org-sunrise',
        amountCents: partyAmount,
        narrative: 'The offer reflects acuity, complexity, and resources used.',
        attributes: { practiceSize: 'Independent group', specialty: 'Emergency medicine' },
        submitted: partySubmitted,
        documents: [],
      },
      {
        id: `${id}-plan`,
        organizationId: 'org-plan',
        amountCents: planAmount,
        narrative: 'The offer reflects the QPA and permitted case-specific factors.',
        attributes: { coverageArea: 'New Jersey', planType: 'Commercial' },
        submitted: true,
        documents: [],
      },
    ],
  };
}

function reviewCase(number: string, cms: string, state: ReviewAssignmentState, urgency: number, lines: CanonicalLineItem[]): CanonicalReviewCase {
  return {
    id: `case-${number}`,
    forthrightCaseNumber: number,
    cmsDisputeNumber: cms,
    partyOrganizationId: 'org-sunrise',
    partyOrganizationName: 'Sunrise Emergency Physicians',
    counterpartyOrganizationName: 'Acme Health Plan',
    assignmentOwnerId: 'reviewer-a',
    assignmentOwnerName: 'Jordan Lee',
    assignmentState: state,
    assignmentDueLabel: state === 'Overdue acceptance' ? 'Due August 31, 2026' : 'Due September 8, 2026',
    urgency,
    revision: 1,
    lineItems: lines,
    documents: [document(`${number}-doc-1`, 'Clinical summary.txt', 'source-clinical-summary'), document(`${number}-doc-2`, 'Plan response.txt', 'source-plan-response')],
    paymentState: 'paid',
    publishedDetermination:
      number === 'NS100242'
        ? {
            sentDate: 'August 31, 2026',
            outcome: 'Your offer was selected',
            body: 'After considering the submitted offers, QPA, and permitted information, the certified IDR entity selected the provider offer.',
          }
        : null,
    determination: state === 'In progress' ? { choices: {}, rationale: '', revision: 1, previewedRevision: null } : null,
    declinedReviewerIds: [],
    completedAt: state === 'Completed' ? 'September 1, 2026 at 2:15 PM ET' : null,
  };
}

const batchLines = Array.from({ length: 50 }, (_, index) => line(`BATCH-${index + 1}`, index % 2 ? '99284' : '99285', 115_000 + index * 500, 165_000 + index * 1_000, 130_000 + index * 750));

export const REVIEW_CASE_FIXTURES: readonly CanonicalReviewCase[] = [
  reviewCase('NS100237', 'CMS-2026-004821', 'Needs acceptance', 2, [line('LI-1', '99284', 115_000, 290_000, 145_000, false)]),
  reviewCase('NS100241', 'CMS-2026-004901', 'Overdue acceptance', 1, [line('LI-1', '99284', 115_000, 290_000, 145_000), line('LI-2', '99285', 172_500, 457_500, 220_000)]),
  reviewCase('NS100239', 'CMS-2026-004851', 'In progress', 3, [line('LI-1', '99284', 115_000, 324_000, 160_000)]),
  reviewCase('NS100247', 'CMS-2026-005040', 'In progress', 4, batchLines),
  reviewCase('NS100242', 'CMS-2026-004934', 'Completed', 5, [line('LI-1', '99284', 115_000, 245_000, 150_000)]),
  { ...reviewCase('NS100250', 'CMS-2026-005101', 'In progress', 6, [line('LI-1', '99284', null, null, null)]), determination: { choices: {}, rationale: '', revision: 1, previewedRevision: null } },
];
